import React, { useState } from 'react';
import logo from '../../assets/img/56.png';

const RecuperarPage = ({ setCurrentPage }) => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!email.trim()) {
      setError('Por favor ingresa tu correo electrónico');
      return;
    }

    if (!/\S+@\S+\.\S+/.test(email)) {
      setError('Por favor ingresa un correo válido');
      return;
    }

    setLoading(true);
    setError('');

    try {
      const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:4000/api/v1';
      const response = await fetch(`${API_URL}/auth/forgot-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || 'Error al enviar link de recuperación');
      }

      setSuccess(true);
    } catch (err) {
      setError(err.message || 'Error al procesar solicitud. Intenta nuevamente.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-gray-100 flex justify-center items-center p-4">
      <div className="absolute top-0 left-0 w-full h-2 bg-[#1e3a8a]"></div>

      <div className="bg-white p-8 shadow-xl rounded-2xl w-full max-w-md border border-gray-100">
        {/* Logo */}
        <div className="flex justify-center mb-6">
          <img
            src={logo}
            alt="EBID Logo"
            className="w-20 h-20 object-contain"
          />
        </div>

        {/* Título */}
        <h2 className="text-2xl font-bold text-center text-[#1e3a8a] mb-2">
          Recuperar Contraseña
        </h2>
        <p className="text-center text-gray-600 mb-6">
          Ingresa tu correo electrónico y te enviaremos un enlace para restablecer tu contraseña
        </p>

        {!success ? (
          <form onSubmit={handleSubmit}>
            <div className="mb-6">
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Correo Electrónico
              </label>
              <input
                type="email"
                value={email}
                onChange={(e) => {
                  setEmail(e.target.value);
                  setError('');
                }}
                className={`w-full px-4 py-3 border-2 rounded-lg focus:outline-none transition
                  ${error ? 'border-red-500' : 'border-gray-300 focus:border-blue-500'}`}
                placeholder="tu@email.com"
              />
              {error && (
                <p className="mt-2 text-sm text-red-600">{error}</p>
              )}
            </div>

            <button
              type="submit"
              disabled={loading}
              className={`w-full bg-[#1e3a8a] text-white py-3 rounded-full font-semibold transition mb-4
                ${loading ? 'opacity-50 cursor-not-allowed' : 'hover:bg-[#2c4a9a]'}`}
            >
              {loading ? 'Enviando...' : 'Enviar Link de Recuperación'}
            </button>
          </form>
        ) : (
          <div className="text-center">
            <div className="mb-6 p-4 bg-green-50 border border-green-200 rounded-lg">
              <p className="text-green-700 font-medium">
                ¡Link enviado!
              </p>
              <p className="text-sm text-green-600 mt-2">
                Revisa tu correo electrónico y sigue las instrucciones para restablecer tu contraseña.
              </p>
            </div>

            <p className="text-sm text-gray-600 mb-4">
              Si no recibes el correo en unos minutos, revisa tu carpeta de spam.
            </p>

            <button
              onClick={() => setCurrentPage('login')}
              className="text-[#1e3a8a] hover:underline font-medium"
            >
              Volver a Iniciar Sesión
            </button>
          </div>
        )}

        {!success && (
          <div className="text-center mt-4">
            <button
              onClick={() => setCurrentPage('login')}
              className="text-[#1e3a8a] hover:underline text-sm"
            >
              Volver a Iniciar Sesión
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default RecuperarPage;